import Flex from 'antd/lib/flex'
import { ReactNode } from 'react'
import MarkdownPreviewComponent from 'Tasks/CustomTask/UI/common/MarkdownPreviewComponent/MarkdownPreviewComponent'
import classes from './FieldWithMarkdownPreview.module.less'

type FieldWithMarkdownPreviewProps = {
    component: ReactNode
    value: string
    showPreview: boolean
}

const FieldWithMarkdownPreview = ({
    component,
    value,
    showPreview,
}: FieldWithMarkdownPreviewProps) => {
    return (
        <Flex vertical>
            {component}
            {showPreview && (
                <Flex className={classes.previewContainer}>
                    <MarkdownPreviewComponent content={value} />
                </Flex>
            )}
        </Flex>
    )
}

export default FieldWithMarkdownPreview
